import styled from 'styled-components'

export const TextSection = styled.div`
  position: relative;
  text-align: ${({ layout }) => (layout === `half` ? `left` : `center`)};
`
